export default __webpack_public_path__ + "media/metronic/_theme/media/company-logos/logo-4-805000df0a74f8ae112df929c3043da9.png";